import {Navigate, Outlet, useLocation} from "react-router";
import {useAuth} from "./AuthContext";
import {LoadingSpinner} from "../components/LoadingSpinner";

// Signed-out visitors go to the login screen, and come back here afterwards.
export function RequireAuth() {
    const {user, loading} = useAuth();
    const location = useLocation();
    if (loading) {
        return <LoadingSpinner/>;
    }
    if (!user) {
        const returnTo = location.pathname + location.search;
        return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace/>;
    }
    return <Outlet/>;
}
